import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';

export default class AuthorizeRoute extends Route {
  @service session;
  @service router;
  @service notify;
  @service intl;

  queryParams = {
    code: { refreshModel: true },
    state: { refreshModel: true },
    error: { refreshModel: true },
    error_description: { refreshModel: true },
  };

  async beforeModel() {
    this.session.prohibitAuthentication('index');
  }

  async model(params) {
    // Try authenticate and redirect to the original route or login page.

    const encodedUrl = params.state?.split('~')[1];
    let returnUrl = 'login';
    if (isPresent(encodedUrl)) {
      try {
        returnUrl = window.atob(encodedUrl);
      } catch (error) {
        console.warn('Invalid return url.', error);
      }
    }

    if (isPresent(params.error)) {
      const message = params.error_description || this.intl.t('login.error');
      this.notify.alert(message, params.error);
      this.router.transitionTo(returnUrl);
      return;
    }

    this.notify.startWorkingOnIt();
    try {
      await this.session.authenticate('authenticator:oidc-auth-code', params);
    } catch (error) {
      const message = this.intl.t('login.error');
      this.notify.alert(message, error);
    } finally {
      this.notify.stopWorkingOnIt();
    }

    this.router.transitionTo(returnUrl);
  }
}
